<div id="partners" class="partners-anchor"></div>
<h2 class="block-title partners-title">{{ "Menu-6" | translate }}</h2>
<div class="partners-logos">
  <a class="partner-logo" href="https://www.conseq.cz/" target="_blank" rel="noopener noreferrer">
    <img src="assets/img/design-2026/CONSEQ-logo-partner.png" alt="CQ logo">
  </a>
  <a class="partner-logo" href="https://www.eic.eu/" target="_blank" rel="noopener noreferrer">
    <img src="assets/img/design-2026/EIC-logo-partner.png" alt="EIC logo">
  </a>
</div>
